// Hotspot coordinates picked from each 32×32 sprite's actual glyph (fingertip/striking
// face/blade tip/palm center) so the cursor "clicks" from the visually correct point, not its
// corner. Keep the 'idle' and 'disabled' entries in sync with styles.css — plain CSS can't
// import a JS/TS constant, so those two are duplicated there (idle as html's default, disabled
// as the button:disabled rule).
const CURSOR_CSS = {
    idle: "url(/assets/sprites/cursors/hand_open.png) 15 15, grab",
    action: "url(/assets/sprites/cursors/hand_point.png) 3 21, pointer",
    hammer: "url(/assets/sprites/cursors/tool_hammer.png) 4 14, crosshair",
    shovel: "url(/assets/sprites/cursors/tool_shovel.png) 6 6, crosshair",
    grabbing: "url(/assets/sprites/cursors/hand_closed.png) 16 15, grabbing",
    disabled: "url(/assets/sprites/cursors/disabled.png) 16 16, not-allowed",
};
let canvasEl = null;
let current = null;
let placementActive = false;
export function initCursor(canvas) {
    canvasEl = canvas;
    current = null;
    setCursor("idle");
}
export function setCursor(kind) {
    if (!canvasEl || current === kind)
        return;
    current = kind;
    canvasEl.style.cursor = CURSOR_CSS[kind];
}
// While placing a special building, GameScene's tile-hover preview (hammer/disabled) owns the
// cursor for every tile, including ones a building sits on — a placement target is either valid
// or it isn't, regardless of what's already there. Building's own hover handlers check this so
// they don't fight the preview with 'action'/'shovel' just because the pointer is over a building.
export function setPlacementActive(active) {
    placementActive = active;
}
export function isPlacementActive() {
    return placementActive;
}
